import React from "react";
import moment from "moment";
import Chart from "react-apexcharts";
import { Card, Col, Row } from "react-bootstrap";
import { groupDataByWeekAndDay } from "../../utils/datetime";
import { useTranslation } from "react-i18next";

const PlanBarChart = ({ assigmentsData = [] }) => {
	const { t } = useTranslation();
	// Obtener datos agrupados por semana y día
	const weeklyData = groupDataByWeekAndDay(assigmentsData);

	// Nombres de los días de la semana para el eje X
	const dayNames = [
		t('plan.charts.monday'),
		t('plan.charts.tuesday'),
		t('plan.charts.wednesday'),
		t('plan.charts.thursday'),
		t('plan.charts.friday'),
		t('plan.charts.saturday'),
		t('plan.charts.sunday'),
	];

	// Opciones comunes para todos los gráficos de barras
	const getOptions = (weekNumber, year, hasMultipleYears) => ({
		chart: {
			type: "bar",
			stacked: false,
			toolbar: {
				show: false,
			},
		},
		plotOptions: {
			bar: {
				horizontal: false,
				columnWidth: "55%",
				endingShape: "rounded",
			},
		},
		dataLabels: {
			enabled: false,
		},
		stroke: {
			show: true,
			width: 2,
			colors: ["transparent"],
		},
		title: {
			text: hasMultipleYears
				? t('plan.charts.weekWithYear', { week: weekNumber, year })
				: t('plan.charts.week', { week: weekNumber }),
			align: "left",
		},
		xaxis: {
			categories: dayNames,
		},
		yaxis: {
			title: {
				text: t('plan.charts.hours'),
			},
		},
		fill: {
			opacity: 1,
		},
		tooltip: {
			y: {
				formatter: function (val) {
					return val + " " + t('plan.charts.hoursUnit');
				},
			},
		},
		legend: {
			position: "top",
			horizontalAlign: "right",
		},
	});

	return (
		<div className="weekly-charts">
			<Row>
				{weeklyData.map(({ weekNumber, year, hasMultipleYears, series }) => (
					<Col md={6} key={`${year}-W${weekNumber}`}>
						<Card className="mb-4">
							<Card.Body>
								<Chart
									options={getOptions(weekNumber, year, hasMultipleYears)}
									series={series}
									type="bar"
									height={300}
								/>
							</Card.Body>
						</Card>
					</Col>
				))}
			</Row>
		</div>
	);
};

export default PlanBarChart;
